export default __webpack_public_path__ + "static/Canela-Regular-3403029e45b7de8d0e08f605055b95b1.woff2";